import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "upload-container" }
const _hoisted_2 = {
  key: 0,
  class: "preview-wrapper"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "info-text"
}
const _hoisted_5 = { class: "dialog-footer" }

import { ref, computed } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { updateUserAvatar, getUserProfile } from '@/user/api/userApi'; // 导入获取用户资料的API
import { useStore } from 'vuex'; // 导入useStore


interface Props {
  modelValue: boolean;
  currentAvatar?: string;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'uploaded'): void;
  (e: 'close'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AvatarUploadModal',
  props: {
    modelValue: { type: Boolean },
    currentAvatar: { default: '' }
  },
  emits: ["update:modelValue", "uploaded", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const store = useStore(); // 使用store

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const selectedFile = ref<File | null>(null);
const previewUrl = ref<string | null>(null);
const uploading = ref(false);

// 处理文件选择变更
const handleFileChange = (file: any) => {
  const rawFile = file.raw;
  if (!rawFile) return;

  if (!beforeUpload(rawFile)) {
    return;
  }

  selectedFile.value = rawFile;
  
  // 创建预览URL
  if (rawFile) {
    previewUrl.value = URL.createObjectURL(rawFile);
  }
};

// 上传前校验
const beforeUpload = (file: File) => {
  // 检查文件类型
  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
  if (!allowedTypes.includes(file.type)) {
    ElMessage.error('只能上传 JPG/PNG/GIF 格式的图片!');
    return false;
  }

  // 检查文件大小 (2MB)
  const maxSize = 2 * 1024 * 1024; // 2MB
  if (file.size > maxSize) {
    ElMessage.error('图片大小不能超过 2MB!');
    return false;
  }

  return true;
};

// 格式化文件大小
const formatFileSize = (size: number) => {
  if (size < 1024) {
    return size + 'B';
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(1) + 'KB';
  } else {
    return (size / 1024 / 1024).toFixed(1) + 'MB';
  }
};

// 执行上传
const handleUpload = async () => {
  if (!selectedFile.value) {
    ElMessage.warning('请选择要上传的图片');
    return;
  }

  try {
    uploading.value = true;
    
    const response = await updateUserAvatar(selectedFile.value);
    
    if (response.data.code === 1) {
      ElMessage.success('头像更新成功!');
      
      // 上传成功后，获取最新的用户资料并更新store
      try {
        const profileResponse = await getUserProfile();
        console.log('获取的用户资料完整响应:', profileResponse); // 添加调试日志
        
        // 根据API响应结构调整判断逻辑
        if (profileResponse && profileResponse.data && profileResponse.data.code === 1) {
          // 检查返回的用户资料中是否包含头像信息
          console.log('返回的用户资料数据:', profileResponse.data.data);
          console.log('返回的头像信息:', profileResponse.data.data?.avatar);
          
          // 更新用户信息到store（注意：API返回的数据结构是 {code: 1, data: {...}}）
          store.commit('SET_USER_INFO', profileResponse.data.data);
          console.log('用户资料已更新到store:', profileResponse.data.data);
        } else {
          console.error('获取用户资料失败:', profileResponse?.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取最新用户资料时发生错误:', error);
      }
      
      emit('uploaded'); // 不再传递URL，因为我们已经更新了store中的用户信息
      
      // 关闭弹窗
      handleClose();
    } else {
      ElMessage.error(response.data.msg || '头像更新失败');
    }
  } catch (error: any) {
    console.error('头像上传失败:', error);
    ElMessage.error(error.message || '头像上传失败，请稍后重试');
  } finally {
    uploading.value = false;
  }
};

// 关闭弹窗
const handleClose = () => {
  // 清理预览URL
  if (previewUrl.value) {
    URL.revokeObjectURL(previewUrl.value);
    previewUrl.value = null;
  }
  
  selectedFile.value = null;
  emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    title: "更换头像",
    width: "400px",
    "close-on-click-modal": false,
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleUpload,
          loading: uploading.value,
          disabled: !selectedFile.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(uploading.value ? '上传中...' : '确认上传'), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (previewUrl.value || __props.currentAvatar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: previewUrl.value || __props.currentAvatar,
                alt: '头像预览',
                class: "preview-image"
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_upload, {
          ref: "uploadRef",
          class: "upload-wrapper",
          action: "#",
          "auto-upload": false,
          "show-file-list": false,
          accept: "image/*",
          "on-change": handleFileChange,
          "before-upload": beforeUpload
        }, {
          tip: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "el-upload__tip" }, " 支持JPG、PNG格式，大小不超过2MB ", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "select-btn"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("选择图片", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 512),
        (selectedFile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 已选择: " + _toDisplayString(selectedFile.value.name) + " (" + _toDisplayString(formatFileSize(selectedFile.value.size)) + ") ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})